import React, { useState } from "react";
import { Grid, Typography, Button } from "@mui/material";
import { service } from "../../model/service";

const ModalOtpExpired = ({ isIta, onClose, uid }) => {
  const [view, setView] = useState("expired");
  const [loading, setLoading] = useState(false);

  const handleRegenerate = async () => {
    try {
      setLoading(true);
      await service.regenerateToken(uid);
      setView("success");
    } catch (err) {
      setView("error");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    window.location.reload();
  };

  // ── Success ──
  if (view === "success") {
    return (
      <Grid
        container
        item
        xs={11}
        md={5}
        sx={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "#fff",
          maxHeight: "90%",
          borderRadius: "16px",
          outline: "none",
          overflow: "auto",
        }}
      >
        <Grid
          item
          xs={12}
          sx={{
            height: 60,
            display: "flex",
            alignItems: "center",
            borderBottom: "1px solid #c6c6c6",
            px: "20px",
          }}
        >
          <Grid item xs={1.5} md={1}>
            <div className="icon-check-success" />
          </Grid>
          <Grid item xs={10.5} md={11}>
            <Typography
              className="color-blue-dark"
              sx={{ fontSize: 18, fontWeight: 600, ml: 1 }}
            >
              {isIta
                ? "Richiesta nuovo codice OTP inviata"
                : "New OTP code request sent"}
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Typography
            className="color-blue-dark"
            sx={{
              padding: "30px 20px 30px",
              fontSize: { xs: "14px", md: "16px" },
            }}
          >
            {isIta
              ? "Controlla la tua casella email per copiare il nuovo codice OTP."
              : "Check your email inbox to copy the new OTP code."}
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "0px 20px 20px",
          }}
        >
          <Button
            sx={{ width: "120px" }}
            className="button-bg-purple"
            onClick={handleClose}
          >
            <Typography
              className="color-light"
              sx={{
                textTransform: "initial",
                fontSize: { xs: "16px", sm: "18px" },
                fontWeight: 500,
              }}
            >
              {isIta ? "Chiudi" : "Close"}
            </Typography>
          </Button>
        </Grid>
      </Grid>
    );
  }

  // ── Error ──
  if (view === "error") {
    return (
      <Grid
        container
        item
        xs={11}
        md={5}
        sx={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "#fff",
          maxHeight: "90%",
          borderRadius: "16px",
          outline: "none",
          overflow: "auto",
        }}
      >
        <Grid
          item
          xs={12}
          sx={{
            height: 60,
            display: "flex",
            alignItems: "center",
            borderBottom: "1px solid #c6c6c6",
            px: "20px",
          }}
        >
          <Grid item xs={1.5} md={0.5}>
            <div className="icon-modal-info" />
          </Grid>
          <Grid item xs={10.5} md={11.5}>
            <Typography
              className="color-blue-dark"
              sx={{ fontSize: 18, fontWeight: 600, ml: 1 }}
            >
              {isIta ? "Errore" : "Error"}
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Typography
            className="color-blue-dark"
            sx={{
              padding: "30px 20px 30px",
              fontSize: { xs: "14px", md: "16px" },
            }}
          >
            {isIta
              ? "Si è verificato un errore durante la richiesta. Riprova più tardi."
              : "An error occurred during the request. Please try again later."}
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "0px 20px 20px",
          }}
        >
          <Button
            sx={{ height: "40px", width: { xs: "120px", md: "140px" } }}
            className="button-bg-purple"
            onClick={handleClose}
          >
            <Typography
              className="color-light"
              sx={{
                textTransform: "initial",
                fontSize: { xs: "16px", sm: "18px" },
                fontWeight: 500,
              }}
            >
              {isIta ? "Chiudi" : "Close"}
            </Typography>
          </Button>
        </Grid>
      </Grid>
    );
  }

  // ── Expired (default) ──
  return (
    <Grid
      container
      item
      xs={11}
      md={5}
      sx={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: "#fff",
        maxHeight: "90%",
        borderRadius: "16px",
        outline: "none",
        overflow: "auto",
      }}
    >
      <Grid
        item
        xs={12}
        sx={{
          height: 60,
          display: "flex",
          alignItems: "center",
          borderBottom: "1px solid #c6c6c6",
          px: "20px",
        }}
      >
        <Grid item xs={1.5} md={0.5}>
          <div className="icon-modal-otp" />
        </Grid>
        <Grid item xs={10.5} md={11.5} sx={{ ml: { xs: 3, sm: 1 } }}>
          <Typography
            className="color-blue-dark"
            sx={{ fontSize: 18, fontWeight: 600, ml: 1 }}
          >
            {isIta ? "Codice OTP scaduto" : "OTP code expired"}
          </Typography>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Typography
          className="color-blue-dark"
          sx={{
            padding: "30px 20px 10px",
            fontSize: { xs: "14px", md: "16px" },
          }}
        >
          {isIta
            ? 'Per accedere alla procedura di raccolta dati ai fini anti-riciclaggio clicca su "Richiedi" e riceverai un nuovo codice OTP alla tua casella email.'
            : 'To access the anti-money laundering data collection procedure, click "Request" and you will receive a new OTP code in your email inbox.'}
        </Typography>
      </Grid>

      <Grid
        item
        xs={12}
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          padding: "0px 20px 20px",
        }}
      >
        <Button
          sx={{ width: "120px", mt: "20px" }}
          className="button-bg-purple"
          disabled={loading}
          onClick={handleRegenerate}
        >
          <Typography
            className="color-light"
            sx={{
              textTransform: "initial",
              fontSize: { xs: "16px", sm: "18px" },
              fontWeight: 500,
            }}
          >
            {isIta ? "Richiedi" : "Request"}
          </Typography>
        </Button>
      </Grid>
    </Grid>
  );
};

export default ModalOtpExpired;
